<!--
component: BrowseKosaku
author: Kota Izumi
description: 工作物台帳閲覧画面
-->
<template>
  <section class="browse-elevator">
		<v-container fluid>
      <v-row>
      <div class="split">
        <div class="split left-box">
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-btn @click="printDaicho()"
                  dark color="#bb5577" x-large width="90%"
                  class="text-h5 mx-3 my-3">
                  印刷
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <div class="split right-box">
          <div class="A4yoko preview-pane" v-if="dispImage">
            <img :src="imageUrl" alt="Image" style="width: 100%;" ref="image">
          </div>
          <div class="A4 preview-pane" v-if="!dispImage">
            <div class="gaiyo-header left-80">
            {{ukeNo}}
            </div>
            <br>
            <br>
            <p class="gaiyo-section-header">工作物の情報</p>
            <hr>
            <br>
            <div class="gaiyo-row">
              <div class="gaiyo-major-title">【１．確認済証番号・年月日】</div>
            </div>

            <div class="gaiyo-row">
              <div class="gaiyo-items">
                <div class="gaiyo-element left-40" style="width: 90mm;">
                  {{gaiyoData.shinsei.kknN_NO}}</div>
                <div class="gaiyo-element left-135">
                  {{dateTextToWareki(gaiyoData.shinsei.kknN_DAY)}}</div>
              </div>
              <div v-for="(n,index) in wordwrap(gaiyoData.kknnNo,23)" :key="`kknnNo-${index}`">
                <br v-show="index>0"></div>
              <br>
            </div>

            <div class="gaiyo-row">
              <div class="gaiyo-major-title">【２．変更確認済証番号・年月日】</div>
            </div>

            <div class="gaiyo-row">
              <div class="gaiyo-element left-40" style="width: 90mm;" v-if="gaiyoData.henko && gaiyoData.henko.length > 0">
                {{gaiyoData.henko[0].kknN_NO}}</div>
              <div class="gaiyo-element left-135" v-if="gaiyoData.henko && gaiyoData.henko.length > 0">
                {{dateTextToWareki(gaiyoData.henko[0].kknN_DAY)}}</div>
              <br>
              <div v-for="(n,index) in wordwrap(gaiyoData.henkoNo,23)" :key="`henkoNo-${index}`">
                <br v-show="index>0">
              </div>
            </div>

            <div class="gaiyo-row">
              <div class="gaiyo-major-title">【３．検査済証番号・年月日】</div>
            </div>
            <div class="gaiyo-row">
              <div class="gaiyo-items">
                <div class="gaiyo-element left-40" style="width: 90mm;">{{gaiyoData.kanryo.kknN_NO}}</div>
                <div class="gaiyo-element left-135">{{dateTextToWareki(gaiyoData.kanryo.kknN_DAY)}}</div>
              </div>
              <div v-for="(n,index) in wordwrap(gaiyoData.kenzumiNo,23)" :key="`kenzumiNo-${index}`">
                <br v-show="index>0">
              </div>
              <br>
            </div>

            <div class="gaiyo-row">
              <div class="gaiyo-major-title">【４．敷地の位置】</div>
            </div>
            
            <div class="gaiyo-row">
              <div class="gaiyo-minor-title"></div>
              <div class="gaiyo-element left-40">{{gaiyoData.timeiTiban}}</div>
              <br>
              <br>
            </div>

            <div class="gaiyo-row">
              <div class="gaiyo-major-title">【５．工作物の概要】</div>
            </div>

            <div class="gaiyo-row">
              <div class="gaiyo-minor-title">・ 種類</div>
              <div class="gaiyo-element left-40">{{gaiyoData.gaiyo[0].yotoNaiyo}}</div>
              <div v-for="(n,index) in wordwrap(gaiyoData.gaiyo[0].yotoNaiyo,33)" :key="`addr-${index}`">
                <br v-show="index>0">
              </div>
            </div>

            <div class="gaiyo-row">
              <div class="gaiyo-minor-title">・ 高さ</div>
              <div v-if="typeof gaiyoData.gaiyo[0].height === 'number' && gaiyoData.gaiyo[0].height >= 0" class="gaiyo-element left-40">{{gaiyoData.gaiyo[0].height}} mm</div>
              <div v-else class="gaiyo-element left-40">{{gaiyoData.gaiyo[0].height}}</div>
              <div v-for="(n,index) in wordwrap(gaiyoData.gaiyo[0].height,33)" :key="`yoto-${index}`">
                <br v-show="index>0">
              </div>
            </div>

            <div class="gaiyo-row">
              <div class="gaiyo-minor-title">・ 構造</div>
              <div class="gaiyo-element left-40">{{gaiyoData.gaiyo[0].gutaiKozoSybt}}</div>
              <div v-for="(n,index) in wordwrap(gaiyoData.gaiyo[0].gutaiKozoSybt,33)" :key="`yoto-${index}`">
                <br v-show="index>0"></div>
            </div>

            <div class="gaiyo-row">
              <div class="gaiyo-major-title">【５．築造主】</div>
            </div>

            <div class="gaiyo-row">
              <div class="gaiyo-minor-title">・ 氏名</div>
              <div class="gaiyo-element left-40">{{gaiyoData.nushi.bldR_NAME_KANJI}}</div>
            </div>

            
            <div class="gaiyo-row" v-if="gaiyoData.nushi.bldR_ADDR">
              <div class="gaiyo-minor-title">・ 所在地</div>
              <div class="gaiyo-element left-40">{{gaiyoData.nushi.bldR_ADDR}}</div>
            </div>

            <br>
            <br>
            <br>

            <div class="gaiyo-row" style="font-size: 11pt;">
            <div>※この資料は、横浜市が保有する台帳から、工作物の情報を抜粋したものです。</div>
            <div style="margin-left: 14px;">横浜市は、当該工作物の存否、築造された詳細な位置、現在の状況等は、把握しておらず、工作物の安全性を証明する資料ではありません。</div>
          </div>

          </div>

        </div>
      </div>
      </v-row>      
    </v-container>
    <Dialog error :open="error!=0" :to="transition"
      title="工作物台帳" :body="errorMessage" />
    <!--
    <Dialog error :open="error!=0" :ok="closeDialog"
      title="工作物台帳" :body="errorMessage" />
    -->
  </section>
</template>

<script>
//import BrowseBuild from '../components/BrowseBuild.vue'
//import ZoomCanvas from '../components/ZoomCanvas.vue';
import Dialog from '../components/Dialog.vue'
import { dateTextToWareki, wordwrap } from '../common/utils'

export default {
  components: {
//    BrowseBuild,
//    ZoomCanvas,
    Dialog,
  },
  data () {
    return {
      error: 0,
      dispImage: false,
      imageUrl: "",
//      image: null,    // オリジナル画像オブジェクト
//      imageWidth: 0,  // オリジナル画像の幅
//      imageHeight: 0, // オリジナル画像の高さ
//      viewerRatio: 1, // 部分拡大窓の拡大率
//      zoomScale: 1,   // ZoomImageViewerに渡すスケール値
//      zoomCenterX: 0, // ZoomImageViewerに渡す画像中心X座標
//      zoomCenterY: 0, // ZoomImageViewerに渡す画像中心Y座標
    }
  },
  computed: {
    gaiyo () {
      return this.$store.state.gaiyoData;
    },
    images () {
      return this.$store.state.gaiyoData.imageNames;
    },
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
    ukeNo () {
      return this.$store.state.ukeNo;
    },
    gaiyoId () {
      return this.$store.state.gaiyoId;
    },
    //gaiyo () {
    //  return this.gaiyoData;
    //},
    gaiyoData () {
      return this.$store.state.gaiyoData;
    },
    kosakuData () {
      return this.$store.state.kosakuData;
    },
    errorMessage () {
      switch (this.error) {
        case 1:
          return 'ユーザが無効です。ログインし直して下さい。';
        case 2:
          return '工作物台帳データが取得できません。'
        default:
          return '';
      }
    },
    transition () {
      switch (this.error) {
        case 1:
          return '/';
        case 2:
          return 'back'
        default:
          return '';
      }
    },
  },
  created () {
  },
  mounted() {
    if (this.unauthorized) {
      this.error = 1;
    }
    this.$store.commit('setCurrentPage', 8);
    this.message = `受付番号：${this.ukeNo}`;
  },
  methods: {
    showPage(url) {
      this.imageUrl = url;
      if (url.length === 0) {
        this.dispImage = false;
      } else {
        console.log(url);
        this.dispImage = true;
      }
    },
    /*
    closeDialog () {
      if (this.error == 1) {
        this.$router.replace('/');
      }
      else if (this.error == 2) {
        this.$router.back();
      }
      this.error = 0;
    },
    */
    /**
     * 工作物工作物台帳プレビュー画面を指定idまでスクロールする
     */
    scrollTo (id) {
      const el = this.$refs[id];
      el.scrollIntoView({ behavior: 'smooth' });
    },
    /**
     * 工作物台帳を印刷する
     */
    printDaicho () {
      if (this.gaiyo != null) {
        this.$store.commit('setPrinting', true);
        window.print();
        this.$store.commit('setPrinting', false);
      }
    },
    dateTextToWareki(date) {
      return dateTextToWareki(date);  // from common/utils.js
    },
    wordwrap(text, len) {
      return wordwrap(text, len);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/common/common.css";
@import "../styles/gaiyo.css";
.A4 {
  /*
  width: 210mm;
  height: 296mm;
  */
  width: 190mm;
  height: 276mm;
  /*
  width: 172mm;
  height: 251mm;
  */
  page-break-after: auto;
  position: relative; 
}
.A4yoko {
  /*
  width: 210mm;
  height: 296mm;
  */
  width: 276mm;
  height: 190mm;
  /*
  width: 172mm;
  height: 251mm;
  */
  page-break-after: auto;
  position: relative; 
}
/* 未使用
.item-row {
  font-size: small;
  line-height: 1;
  //margin-top: -1.2em;
  //margin-bottom: -1.2em;
}
*/
///* gaiyo.cssに任せてみる
.gaiyo-header {
  text-align: right;  
}
.gaiyo-section-header {
  font-size: 14pt;
}
.gaiyo-row {
  line-height: 8mm;
  display: flex; /* Flexboxを有効化 */
  flex-direction: column; /* 要素を縦方向に並べる */
}
.gaiyo-major-title {
  font-size: 12pt;
}
.gaiyo-minor-title {
  font-size: 11pt;
}
.gaiyo-element {
  font-size: 11pt;
}
.left-40 {
  width: 130mm;
}
.left-130 {
  width: 50mm;
}
.left-135 {
  width: 50mm;
}
.split {
  position: absolute;
  width: 98%;
  height: 95%;
  padding: 0.0em;
  margin: 0;
}
.left-box {
  left: 0;
  width: 25%;
  padding: 0.3em;
  overflow-y: auto;
}
.right-box {
  right: 0;
  width: 75%;
  height: 100%;
  padding: 0 0.5em;
  overflow-y: scroll;
  overflow-x: auto;
  background-color: rgb(198, 226, 225);
}
.active {
  background-color: aquamarine;
}
.footer-inside-A4 {
  position: absolute;
  bottom: 16px;
  width: calc(100% - 16px);
  text-align: left;
  padding: 10px;
}
@media print {
  @page {
    //size: A4 portrait !important;
    size: auto !important;
  }
  * {
    background: none !important;
    //overflow: hidden;
  }
  body {
    background: none !important;
    background-color: white !important;
  }
  .A4 {
    background: none !important;
    background-color: white !important;
  }
  .split {
    background: none !important;
    background-color: white !important;
  }
  .left-box {
    visibility: hidden;
    width: 0%;
  }
  .right-box {
    width: 100%;
    //overflow-x: hidden;
    //overflow-y: hidden;
    overflow-x: visible;
    overflow-y: visible;
    background: none !important;
    background-color: white !important;
  }
  .preview-pane {
    background: white;
    //width: 100% !important;
    //height: 100% !important;
  }
  /*
  .A4 {
    width: 190mm;
    height: 276mm;
    page-break-after: auto;
  }
  */
  /*
  @page {
    margin: 15mm 0 0;
  }
  body {
    margin: 0mm;
  }
  */
  main {
    margin: 0mm;
  }
}

</style>